const MODULE = document.querySelectorAll('[data-module="faq"]');

class Faq {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const items = component.querySelectorAll('.faq-item');

            items.forEach((item) => {
                const trigger = item.querySelector('.faq-item-trigger');
                if (!trigger) return;

                trigger.addEventListener('click', () => {
                    const isOpen = item.classList.contains('is-active');

                    items.forEach((otherItem) => this.close(otherItem));

                    if (!isOpen) {
                        this.open(item);
                    }
                });
            });
        });
    }

    open(item) {
        item.classList.add('is-active');
        item.querySelector('.faq-item-trigger')?.setAttribute('aria-expanded', 'true');
    }

    close(item) {
        item.classList.remove('is-active');
        item.querySelector('.faq-item-trigger')?.setAttribute('aria-expanded', 'false');
    }
}

(() => {
    if (MODULE.length) {
        new Faq();
    }
})();

export default Faq;
